<ng-container *ngIf="formArray">
  <div *ngFor="let controls of arrayControls; let i = index">
    <div [ngClass]="{ 'text-right': type == 'phone' || i > 0, first: i == 0 }">
      <ng-container *ngIf="i == 0 && !outsider">
        <b *ngIf="type == 'email'">{{ 'user.contactMail' | loc }}</b>
        <b *ngIf="type == 'phone'">{{ 'user.contactPhone' | loc }}</b>
      </ng-container>
    </div>
    <div class="communication-input">
      <app-text-input [formControl]="controls" *ngIf="type == 'email'"></app-text-input>
      <app-contact-phone-type-form
      *ngIf="type == 'phone'"
      [formControl]="controls"
      [outsideLabel]="false"
    ></app-contact-phone-type-form>
    <div class="communication-buttons">
      <app-order-buttons *ngIf="arrayControls.length > 1" [array]="formArray" [index]="i"></app-order-buttons>
      <mat-icon inline class="mat-primary font-26 cursor-pointer" (click)="onDelete(i)"> delete </mat-icon>
    </div>
  </div>
  </div>
  <div class="add-new-list-element">
    <app-form-button icon="add" [textKey]="'label.add' + (type == 'email' ? 'Email' : 'Phone')" (click)="onAdd(null)">
    </app-form-button>
  </div>
  <mat-error *ngIf="arrayControls.length == 0 && required" class="mat-warn">
    {{ 'label.one' + (type == 'email' ? 'Email' : 'Phone') | loc }}
  </mat-error>
</ng-container>
